import React from "react";
import "./CancellationPolicy.css";
import { format } from "path";
import { formatDate } from "@/utils/helper";
// Types for Option 1
interface CancellationPolicyOption1 {
  amount_type: string;
  details: {
    currency: string;
    from: string;
    nights: number;
  }[];
  no_show_fee: {
    amount_type: string;
    currency: string;
    nights: number;
  };
  under_cancellation: boolean;
}

// Types for Option 2
interface CancellationPolicyOption2 {
  amount_type: string;
  cancel_by_date: string;
  details: {
    currency: string;
    flat_fee: number;
    from: string;
  }[];
  no_show_fee: {
    amount_type: string;
    currency: string;
    flat_fee: number;
  };
  under_cancellation: boolean;
}
interface CancellationPolicyOption3 {
  amount_type: string;
  cancel_by_date: string;
  details: {
    currency: string;
    percent: number;
    from: string;
  }[];
  no_show_fee: {
    amount_type: string;
    currency: string;
    percent: number;
  };
  under_cancellation: boolean;
}

// Union type for both options
type CancellationPolicy =
  | CancellationPolicyOption1
  | CancellationPolicyOption2
  | CancellationPolicyOption3;
// Reusable component
interface Props {
  data: CancellationPolicy;
}

const CancellationPolicy = ({ data }: { data: any }) => {
  const policy = data?.cancellation_policy;
  console.log("policy", policy);
  return (
    <>
        <div className="modal-dialog" >
          <div className="modal-content" style={{ border: 'none'}}>
            <div className="modal-body text-center" id="CancellationPolicy">
              {policy?.amount_type == "nights" && (
                <>
                  {policy?.amount_type == "nights" &&
                    policy?.cancel_by_date && (
                      <div className="card mt-3 col-md-12 col-sm-12">
                        <div className="card-header bg-transparent border-0">
                          <p>
                            <strong>
                              Last date for cancellation without charges
                            </strong>
                          </p>
                        </div>
                        <div className="card-body">
                          <p>
                            <strong>
                              {formatDate(
                                policy?.cancel_by_date,
                                "dd MMM yyyy HH:mm"
                              )}
                            </strong>
                          </p>
                        </div>
                      </div>
                    )}

                  {policy.details.map((detail: any, index: number) => (
                    <div className="card mt-3 col-md-12 col-sm-12">
                      <div className="card-header bg-transparent border-0">
                        <p>
                          <strong>
                            From {formatDate(detail?.from, "dd MMM yyyy HH:mm")}
                          </strong>
                        </p>
                      </div>
                      <div className="card-body">
                        <p>
                          Cancellation charges will apply from{" "}
                          <strong>
                            {" "}
                            {formatDate(detail?.from, "dd MMM yyyy HH:mm")}
                          </strong>{" "}
                          and will be charged at the rate of {detail?.nights}{" "}
                          nights.
                        </p>
                      </div>
                    </div>
                  ))}
                  {policy?.no_show_fee?.amount_type == "nights" && (
                    <div className="card mt-3 col-md-12 col-sm-12">
                      <div className="card-header bg-transparent border-0">
                        <p>
                          <strong>No Show Charges</strong>
                        </p>
                      </div>
                      <div className="card-body">
                        <p>
                          No show fees will apply at the rate of{" "}
                          <strong> {policy?.no_show_fee?.nights} nights</strong>{" "}
                          in <strong>{policy?.no_show_fee?.currency}</strong>
                        </p>
                      </div>
                    </div>
                  )}
                </>
              )}

              {policy?.amount_type === "value" && (
                <>
                  {policy?.amount_type == "value" && policy?.cancel_by_date && (
                    <div className="card mt-3 col-md-12 col-sm-12">
                      <div className="card-header bg-transparent border-0">
                        <p>
                          <strong>
                            Last date for cancellation without charges
                          </strong>
                        </p>
                      </div>
                      <div className="card-body">
                        <p>
                          <strong>
                            {formatDate(
                              policy?.cancel_by_date,
                              "dd MMM yyyy HH:mm"
                            )}
                          </strong>
                        </p>
                      </div>
                    </div>
                  )}

                  {policy.details.map((detail: any, index: number) => (
                    <div className="card mt-3 col-md-12 col-sm-12">
                      <div className="card-header bg-transparent border-0">
                        <p>
                          <strong>
                            After{" "}
                            {formatDate(detail?.from, "dd MMM yyyy HH:mm")}
                          </strong>
                        </p>
                      </div>
                      <div className="card-body">
                        <p>
                          Cancellation charges from{" "}
                          <strong>
                            {formatDate(detail?.from, "dd MMM yyyy HH:mm")}
                          </strong>{" "}
                          and will be charged{" "}
                          <strong>
                            {detail?.currency} {detail?.price_markup}
                          </strong>
                        </p>
                      </div>
                    </div>
                  ))}
                  {policy?.no_show_fee?.amount_type == "value" && (
                    <div className="card mt-3 col-md-12 col-sm-12">
                      <div className="card-header bg-transparent border-0">
                        <p>
                          <strong>No Show Charges</strong>
                        </p>
                      </div>
                      <div className="card-body">
                        <p>
                          No show fees will be charged{" "}
                          <strong>
                            {policy?.no_show_fee?.currency}{" "}
                            {policy?.no_show_fee?.price_markup}
                          </strong>
                        </p>
                      </div>
                    </div>
                  )}
                </>
              )}

              {policy?.amount_type === "percent" && (
                <>
                  {policy?.no_show_fee?.amount_type == "percent" &&
                    policy?.cancel_by_date && (
                      <div className="card mt-3 col-md-12 col-sm-12">
                        <div className="card-header bg-transparent border-0">
                          <p>
                            <strong>
                              Last date for cancellation without charges
                            </strong>
                          </p>
                        </div>
                        <div className="card-body">
                          <p>
                            <strong>
                              {formatDate(
                                policy?.cancel_by_date,
                                "dd MMM yyyy HH:mm"
                              )}
                            </strong>
                          </p>
                        </div>
                      </div>
                    )}

                  {policy?.details?.map((detail: any, index: number) => (
                    <div className="card mt-3 col-md-12 col-sm-12">
                      <div className="card-header bg-transparent border-0">
                        <p>
                          <strong>
                            After{" "}
                            {formatDate(detail?.from, "dd MMM yyyy HH:mm")}
                          </strong>
                        </p>
                      </div>
                      <div className="card-body">
                        <p>
                          Cancellation charges from{" "}
                          <strong>
                            {formatDate(detail?.from, "dd MMM yyyy HH:mm")}
                          </strong>{" "}
                          and will be charged{" "}
                          <strong>
                            {detail?.currency} {detail?.percent} %
                          </strong>
                        </p>
                      </div>
                    </div>
                  ))}
                  {policy?.no_show_fee?.amount_type == "percent" && (
                    <div className="card mt-3 col-md-12 col-sm-12">
                      <div className="card-header bg-transparent border-0">
                        <p>
                          <strong>No Show Charges</strong>
                        </p>
                      </div>
                      <div className="card-body">
                        <p>
                          No show fees will be charged{" "}
                          <strong>
                            {policy?.no_show_fee?.currency}{" "}
                            {policy?.no_show_fee?.percent} %
                          </strong>
                        </p>
                      </div>
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
    </>
  );
};

export default CancellationPolicy;
